module.exports = __webpack_public_path__ + "img/banner(2).26ca2d81.jpg";